/* eslint-disable @typescript-eslint/explicit-function-return-type */
import type {Routes} from "@angular/router";
import {UserAccountType} from "../../models/users/User";
import {hasUserTypes, isLoggedIn} from "../../services/guards/permission-guard";

export const riskManagementRoutes = [
  {
    path: "risk-management",
    canActivateChild: [isLoggedIn],
    children: [
      {
        path: "dashboard",
        canActivateChild: [hasUserTypes(UserAccountType.Admin, UserAccountType.Bactoforce)],
        children: [
          {
            path: "",
            loadComponent: () => import("./equipment-inspection-types/list/risk-management-equipment-inspection-types-list").then(m => m.RiskManagementEquipmentInspectionTypesList),
          },
        ],
      },
    ],
  },
] as const satisfies Routes;
